import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {createBaseQueryArgs} from './api/createBaseQueryArgs';

export const ebsApi = createApi({
  reducerPath: 'ebsApi',
  baseQuery: fetchBaseQuery(createBaseQueryArgs),
  endpoints: () => ({}),
  tagTypes: ['UserPreference'],
});
